<script setup lang="ts">
const {
  width = '100%',
  height = '1em',
  background = 'var(--color-gray-10)',
} = defineProps<{
  width?: string
  height?: string
  background?: string
}>()
</script>

<template>
  <div
    role="status"
    class="relative inline-block overflow-hidden rounded-xl"
    :style="{ width, height, background }"
  />
</template>

<style scoped>
div::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0,
    rgba(255, 255, 255, 0.2) 20%,
    rgba(255, 255, 255, 0.5) 60%,
    rgba(255, 255, 255, 0)
  );
  animation: shimmer 2s infinite;
  content: '';
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>
